/**
 * Product Specifications Tabs
 * Handles tab switching functionality for multiple instances
 * and dynamic variant specification updates
 */

// Immediate hydration to prevent flash of empty content
(function() {
  hydrateSpecifications();
})();

document.addEventListener('DOMContentLoaded', function() {
  initSpecificationsTabs();
  initVariantSpecifications();
});

function initSpecificationsTabs() {
  // Get all tab containers on the page
  const tabsContainers = document.querySelectorAll('.product-specifications-tabs');
  
  if (!tabsContainers.length) return;
  
  // Initialize each tab container separately
  tabsContainers.forEach((tabsContainer, containerIndex) => {
    const tabButtons = tabsContainer.querySelectorAll('.specifications-tab__btn');
    const tabPanels = tabsContainer.querySelectorAll('.specifications-tab__panel');
    
    // Add data attributes to panels for easier targeting
    tabPanels.forEach((panel) => {
      const panelId = panel.id;
      if (panelId) {
        // Extract the tab name from the ID (e.g., "tab-about" -> "about")
        const tabName = panelId.replace('tab-', '');
        panel.setAttribute('data-tab-panel', tabName);
        panel.setAttribute('data-container-index', containerIndex);
      }
    });
    
    // Mark container as initialized
    tabsContainer.classList.add('is-initialized');
    
    // Add click event listeners to tab buttons
    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        const targetTab = this.dataset.tab;
        
        // Remove active class from all buttons and panels in this container
        tabButtons.forEach(btn => btn.classList.remove('is-active'));
        tabPanels.forEach(panel => panel.classList.remove('is-active'));
        
        // Add active class to clicked button
        this.classList.add('is-active');
        
        // Show corresponding panel using data attributes
        const targetPanel = tabsContainer.querySelector(`[data-tab-panel="${targetTab}"][data-container-index="${containerIndex}"]`);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }
      });
    });
    
    // Set up keyboard navigation
    tabButtons.forEach((button, index) => {
      button.addEventListener('keydown', function(e) {
        let newIndex;
        
        switch(e.key) {
          case 'ArrowRight':
            e.preventDefault();
            newIndex = (index + 1) % tabButtons.length;
            tabButtons[newIndex].click();
            tabButtons[newIndex].focus();
            break;
            
          case 'ArrowLeft':
            e.preventDefault();
            newIndex = (index - 1 + tabButtons.length) % tabButtons.length;
            tabButtons[newIndex].click();
            tabButtons[newIndex].focus();
            break;
            
          case 'Home':
            e.preventDefault();
            tabButtons[0].click();
            tabButtons[0].focus();
            break;
            
          case 'End':
            e.preventDefault();
            tabButtons[tabButtons.length - 1].click();
            tabButtons[tabButtons.length - 1].focus();
            break;
        }
      });
    });
  });
}

/**
 * Initialize variant specifications updates
 * Listens for variant changes and updates specification values
 */
function initVariantSpecifications() {
  // Get the first data element (they should all have the same data)
  const dataElements = document.querySelectorAll('#product-specifications-data');
  if (!dataElements.length) return;
  
  let specificationsData;
  try {
    // Use the first data element
    specificationsData = JSON.parse(dataElements[0].textContent);
  } catch (e) {
    console.error('Failed to parse specifications data:', e);
    return;
  }
  
  // Listen for variant change events
  document.addEventListener('on:variant:change', function(event) {
    const variant = event.detail.variant;
    if (!variant || !variant.id) return;
    
    updateSpecifications(variant.id, specificationsData);
  });
  
  // Also listen for URL changes (back/forward navigation)
  window.addEventListener('popstate', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    if (variantId) {
      updateSpecifications(variantId, specificationsData);
    }
  });
}

/**
 * Update specification values based on selected variant
 * @param {string|number} variantId - The ID of the selected variant
 * @param {object} data - The specifications data object
 */
function updateSpecifications(variantId, data) {
  if (!data.variants || !data.variants[variantId]) {
    console.warn('No specifications data found for variant:', variantId);
    return;
  }
  
  const variantData = data.variants[variantId];
  
  // Update each specification value in ALL instances (mobile and desktop)
  Object.keys(variantData).forEach(key => {
    const rows = document.querySelectorAll(`[data-spec-row="${key}"]`);
    const elements = document.querySelectorAll(`[data-spec="${key}"]`);
    
    rows.forEach(row => {
      const value = variantData[key];
      const hasValue = value !== null && value !== undefined && value !== '';
      
      // Show/hide the row based on whether it has a value
      if (hasValue) {
        row.removeAttribute('data-empty');
        row.style.display = ''; // Reset to default display
      } else {
        row.setAttribute('data-empty', 'true');
      }
    });
    
    elements.forEach(element => {
      const value = variantData[key];
      if (value !== null && value !== undefined && value !== '') {
        element.textContent = String(value);
      }
    });
  });
}

/**
 * Initial hydration of specifications
 * Runs immediately to prevent flash of empty content
 */
function hydrateSpecifications() {
  try {
    const dataElement = document.getElementById('product-specifications-data');
    if (!dataElement) return;
    
    const data = JSON.parse(dataElement.textContent);
    const variantId = data.selectedVariantId;
    
    if (variantId && data.variants && data.variants[variantId]) {
      updateSpecifications(variantId, data);
    }
    
    // Make tabs visible and trigger animations after hydration
    const tabContainers = document.querySelectorAll('.product-specifications-tabs');
    tabContainers.forEach((container, index) => {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        container.style.opacity = '1';
        container.style.visibility = 'visible';
        container.classList.add('is-initialized');
        
        // Trigger staggered animation after a brief delay
        setTimeout(() => {
          container.classList.add('is-loaded');
        }, 50);
      }, index * 50); // Slight delay between mobile and desktop versions
    });
  } catch (e) {
    console.error('Failed to hydrate specifications:', e);
  }
} 